import Info from "./info"
import OverallExperience from "./overall_experience"
import Status from "./status"
import ExperienceWrapper from "./experience_wrapper";
import LabDataMetrics from "./lab_data_metrics";
import OpportunityWrapper from "./opportunity_wrapper";
import UnderstandPageWeight from "./understand_page_weight";
import ContactExpert from "../contact/expert";
import dateFormat, { masks } from "dateformat";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import TalkToExpert from "../contact/talkToExpert";
import UrlDateCopy from "../common/urlDateCopy";
import Footer from '../common/footer';
import ContactForm from "../common/contactForm";
import CtaOne from "../contact/cta_one";
import CtaTwo from "../contact/cta_two";
import Popup1 from "../contact/popup1";

function Audit(props){
    let localDate = new Date(props.date)
    localDate = dateFormat(localDate, "mmmm dS yyyy h:MM:ss TT")
    let auditDetails = props.auditDetails

    // Calculate isDisplayShowMore which is the opposite of isShowRecommendations
    const isDisplayShowMore = !props.isShowRecommendations;
    
    // Create and add global CSS styles on component mount to control blur consistently
    useEffect(() => {
        // Create a style element for global blur control
        const styleElement = document.createElement('style');
        styleElement.id = 'blur-control-styles';
        document.head.appendChild(styleElement);
        
        // Function to update global CSS based on current state
        const updateBlurStyles = () => {
            // Apply or remove blur based on isDisplayShowMore
            const cssRules = `
                /* When isDisplayShowMore is true or isBulk is true, ensure NO blur */
                .no-blur, .no-blur * {
                    filter: none !important;
                    -webkit-filter: none !important;
                }
                
                /* Root level blur control */
                #root {
                    filter: ${isDisplayShowMore || props.isBulk ? 'none !important' : 'blur(6px)'};
                    -webkit-filter: ${isDisplayShowMore || props.isBulk ? 'none !important' : 'blur(6px)'};
                }
                
                /* Device-specific content blur control */
                #${props.device} > div:last-child {
                    filter: ${isDisplayShowMore || props.isBulk ? 'none !important' : 'blur(6px)'};
                    -webkit-filter: ${isDisplayShowMore || props.isBulk ? 'none !important' : 'blur(6px)'};
                }
            `;
            
            styleElement.innerHTML = cssRules;
            console.log('Updated global blur styles based on isDisplayShowMore:', isDisplayShowMore);
        };
        
        // Update styles when component mounts
        updateBlurStyles();
        
        // When isDisplayShowMore changes, update styles and directly manipulate DOM as backup
        const handleDisplayStateChange = () => {
            updateBlurStyles();
            
            // Direct DOM manipulation as backup
            if (isDisplayShowMore || props.isBulk) {
                // Remove blur from root
                const root = document.getElementById('root');
                if (root) root.style.cssText += ';filter: none !important; -webkit-filter: none !important;';
                
                // Remove blur from content div
                const contentDiv = document.querySelector('#' + props.device + ' > div:last-child');
                if (contentDiv) contentDiv.style.cssText += ';filter: none !important; -webkit-filter: none !important;';
                
                console.log('Direct DOM manipulation: removed blur from elements');
            }
        };
        
        // Call handler on mount and when isDisplayShowMore changes
        handleDisplayStateChange();
        
        // Clean up styles on unmount
        return () => {
            if (styleElement && styleElement.parentNode) {
                styleElement.parentNode.removeChild(styleElement);
            }
        };
    }, [isDisplayShowMore, props.isBulk, props.device]);
    
    // Additional effect to ensure blur is removed on initial render
    useEffect(() => {
        // Execute after a short delay to ensure DOM is ready
        const timeoutId = setTimeout(() => {
            if (isDisplayShowMore === true) {
                const contentDiv = document.querySelector('#' + props.device + ' > div:last-child');
                if (contentDiv) {
                    contentDiv.style.cssText += ';filter: none !important; -webkit-filter: none !important;';
                    console.log('Removed blur on initial render after delay');
                }
            }
        }, 200); // Small delay to ensure DOM is ready
        
        return () => clearTimeout(timeoutId);
    }, []);
    
    console.log('isDisplayShowMore:', isDisplayShowMore);
    console.log('isBulk:', props.isBulk);

    return(
        <>
          <Popup1 isDisplayShowMore={!props.isShowRecommendations}/>
          <div id={props.device}>
            <UrlDateCopy redirectInfo={props.redirectInfo} isReportFullyLoaded={props.isReportFullyLoaded} completedAudit={props.completedAudit} selectedAudit={props.selectedAudit} auditDetails={auditDetails} setCopied={props.setCopied} copied={props.copied} date={props.date} url={props.url} />
            <div className="mt-3 status-top">
              <Status url={props.url} device={props.device} date={localDate} cwvStatus={props.data.cwv.status}/>
              <Info device={props.device} setCopied={props.setCopied} copied={props.copied} audits={props['data']['audits']} audits-ylb={props['data-ylb']} config={props.config} scores={props.data.scores}/>              
            </div>
            {/* <TalkToExpert/> */}
            {(props.isShowRecommendations && !props.isBulk) &&
            
            <ContactForm url={props.url} phone={props.phone} setPhone={props.setPhone} buttonText={props.buttonText} setButtonText={props.setButtonText} contactExpert={props.contactExpert} setContactExpert={props.setContactExpert} contactFormSuccessMessage={props.contactFormSuccessMessage} setContactFormSuccessMessage={props.setContactFormSuccessMessage} name={props.name} email={props.email} setName={props.setName} setEmail={props.setEmail} showModal={props.showModal} setShowModal={props.setShowModal} setIsShowRecommendations={props.setIsShowRecommendations}/>

            }
            <div className={isDisplayShowMore ? "no-blur" : "with-blur"} 
                style={{
                  filter: (!isDisplayShowMore && !props.isBulk) ? "blur(6px)" : "none !important", 
                  WebkitFilter: (!isDisplayShowMore && !props.isBulk) ? "blur(6px)" : "none !important"
                }}>
              <OverallExperience experience={props.data.experience}/>
              <ExperienceWrapper data={props.data.cwv} />
              { props?.redirectInfo?.cta_calendar != null &&
                <CtaOne redirectInfo={props.redirectInfo}/>
              }
              <LabDataMetrics device={props.device} data={props.data.audits}/>
              { props?.['data-ylb']?.['totalRequests'] != undefined &&
                <UnderstandPageWeight device={props.device} data_r={props['data-ylb']['totalRequests']} data={props['data-ylb']['totalWeight']}/>
              }
              <OpportunityWrapper redirectInfo={props.redirectInfo} config={props.config} setConfig={props.setConfig} audits={props['data']['audits']} audits-ylb={props['data-ylb']} />
              { props?.redirectInfo?.cta_calendar != null &&
                <CtaTwo redirectInfo={props.redirectInfo}/>
              }
            </div>
          </div>
          {/* <Footer isShowCta={props.isShowCta} redirectInfo={props.redirectInfo} title="Looking for site speed optimization?" content="Book a free consultation with our Certified Experts" buttonText="Talk To Our Expert" expertImg="https://www.thecommerceshop.com/wp-content/uploads/2023/01/sticky-nash.png" /> */}
        </>
    )
}

export default Audit